<div class="card">
  <h2>Beheer</h2>

  <!--  defaultConfirmationTextEN: fb.modelField('defaultConfirmationTextEN'),-->
  <!--  defaultConfirmationTextNL: fb.modelField('defaultConfirmationTextNL'),-->
  <!--  overrideConfirmationStartDate: fb.modelField('overrideConfirmationStartDate'),-->
  <!--  overrideConfirmationEndDate: fb.modelField('overrideConfirmationEndDate'),-->
  <!--  overrideConfirmationTextEN: fb.modelField('overrideConfirmationTextEN'),-->
  <!--  overrideConfirmationTextNL: fb.modelField('overrideConfirmationTextNL'),-->

  <app-form-field [input]="formContainer.componentInput['defaultConfirmationTextEN']"></app-form-field>
  <app-form-field [input]="formContainer.componentInput['defaultConfirmationTextNL']"></app-form-field>
  <app-form-field [input]="formContainer.componentInput['overrideConfirmationStartDate']"></app-form-field>
  <app-form-field [input]="formContainer.componentInput['overrideConfirmationEndDate']"></app-form-field>
  <app-form-field [input]="formContainer.componentInput['overrideConfirmationTextEN']"></app-form-field>
  <app-form-field [input]="formContainer.componentInput['overrideConfirmationTextNL']"></app-form-field>

  <p-button class="save-button" label="Opslaan" icon="pi pi-save" [loading]="saveHelper.saving()" (click)="saveHelper.save()"> </p-button>
</div>
